import { useEffect, useState } from 'react';
import { EditableHeader } from '@/components/form/EditableHeader/EditableHeader';
import { useFeedback } from '@/components/notifications/Feedback/useFeedback';
import { useUpdateFormSubmissionNameMutation } from '../graphql/FormSubmissions.generated';
interface FormSubmissionNameProps {
  submissionId: string;
  name: string;
  disabled: boolean;
}
export function FormSubmissionName({
  submissionId,
  name,
  disabled
}: FormSubmissionNameProps) {
  const [persistedName, setPersistedName] = useState(name);
  const [editorVersion, setEditorVersion] = useState(0);
  const [updateSubmissionName, {
    loading
  }] = useUpdateFormSubmissionNameMutation();
  const {
    showFeedback
  } = useFeedback();
  useEffect(() => {
    setPersistedName(name);
  }, [name]);
  const resetEditor = () => setEditorVersion(version => version + 1);
  const handleNameChange = async (nextName: string) => {
    const trimmedName = nextName.trim();
    if (!trimmedName || trimmedName === persistedName) {
      resetEditor();
      return;
    }
    try {
      const result = await updateSubmissionName({
        variables: {
          input: {
            id: submissionId,
            name: trimmedName
          }
        }
      });
      const updatedName = result.data?.updateFormSubmissionName.name;
      if (!updatedName) {
        throw new Error('The review name was not returned.');
      }
      setPersistedName(updatedName);
    } catch {
      showFeedback('The review name could not be saved. Try again.', {
        variant: 'error'
      });
    } finally {
      resetEditor();
    }
  };
  return <EditableHeader key={`${persistedName}-${editorVersion}`} value={persistedName} onChange={nextName_0 => {
    void handleNameChange(nextName_0);
  }} disabled={disabled || loading} typographyVariant="title-l" typographyProps={{
    component: 'span',
    noWrap: true
  }} testId="form-submission-name" />;
}